import { fetchWithHandling, fetchWithHandlingNoParse } from "../ApiUtils";

const URL = `${process.env.REACT_APP_API_URL}/api/admin/settings`;
const target = "/admin/settings"

/* Membership Requirements */
export const createMembershipRequirement = async (data) => {
    return fetchWithHandlingNoParse(`${URL}/requirement`, target, {
        method: "POST",
        body: JSON.stringify(data)
    });
}

export const getMembershipRequirements = async () => {
    return fetchWithHandling(`${URL}/requirements`, target, {
        method: "GET"
    });
}

export const updateMembershipRequirement = async (data) => {
    return fetchWithHandlingNoParse(`${URL}/requirement`, target, {
        method: "PUT",
        body: JSON.stringify(data)
    });
}

export const deleteMembershipRequirement = async (id) => {
    return fetchWithHandlingNoParse(`${URL}/requirement/${id}`, target, {
        method: "DELETE"
    });
}



/* Event Types */
export const createEventType = async (data) => {
    return fetchWithHandlingNoParse(`${URL}/eventType`, target, {
        method: "POST",
        body: JSON.stringify(data)
    });
}

export const updateEventType = async (data) => {
    return fetchWithHandlingNoParse(`${URL}/eventType`, target, {
        method: "PUT",
        body: JSON.stringify(data)
    });
}

export const deleteEventType = async (id) => {
    return fetchWithHandlingNoParse(`${URL}/eventType/${id}`, target, {
        method: "DELETE"
    });
}



/* Swag Items */
export const createSwagItem = async (data) => {
    return fetchWithHandlingNoParse(`${URL}/swag`, target, {
        method: "POST",
        body: JSON.stringify(data)
    });
}

export const getSwagItems = async () => {
    return fetchWithHandling(`${URL}/swag`, target, {
        method: "GET"
    });
}

export const updateSwagItem = async (data) => {
    return fetchWithHandlingNoParse(`${URL}/swag`, target, {
        method: "PUT",
        bodu: JSON.stringify(data)
    });
}

export const deleteSwagItem = async (id) => {
    return fetchWithHandlingNoParse(`${URL}/swag/${id}`, target, {
        method: "DELETE"
    });
}



/* Semesters */
export const createSemester = async (data) => {
    return fetchWithHandlingNoParse(`${URL}/semester`, target, {
        method: "POST",
        body: JSON.stringify(data)
    });
}

export const getSemesters = async () => {
    return fetchWithHandling(`${URL}/semesters`, target, {
        method: "GET"
    });
}

export const updateSemester = async (data) => {
    return fetchWithHandlingNoParse(`${URL}/semester`, target, {
        method: "PUT",
        body: JSON.stringify(data)
    });
}

export const deleteSemester = async (id) => {
    return fetchWithHandlingNoParse(`${URL}/semester/${id}`, target, {
        method: "DELETE"
    });
}



/* Registration Dropdowns - Genders */
export const createGender = async (data) => {
    return fetchWithHandlingNoParse(`${URL}/gender`, target, {
        method: "POST",
        body: JSON.stringify(data)
    });
}

export const getGenders = async () => {
    return fetchWithHandling(`${URL}/genders`, target, {
        method: "GET"
    });
}

export const updateGender = async (data) => {
    return fetchWithHandlingNoParse(`${URL}/gender`, target, {
        method: "PUT",
        body: JSON.stringify(data)
    });
}

export const deleteGender = async (id) => {
    return fetchWithHandlingNoParse(`${URL}/gender/${id}`, target, {
        method: "DELETE"
    });
}



/* Registration Dropdowns - Pronouns */
export const createPronoun = async (data) => {
    return fetchWithHandlingNoParse(`${URL}/pronoun`, target, {
        method: "POST",
        body: JSON.stringify(data)
    });
}

export const getPronouns = async () => {
    return fetchWithHandling(`${URL}/pronouns`, target, {
        method: "GET"
    });
}

export const updatePronoun = async (data) => {
    return fetchWithHandlingNoParse(`${URL}/pronoun`, target, {
        method: "PUT",
        body: JSON.stringify(data)
    });
}

export const deletePronoun = async (id) => {
    return fetchWithHandlingNoParse(`${URL}/pronoun/${id}`, target, {
        method: "DELETE"
    });
}


/* Registration Dropdowns - Races */
export const createRace = async (data) => {
    return fetchWithHandlingNoParse(`${URL}/race`, target, {
        method: "POST",
        body: JSON.stringify(data)
    });
}

export const getRaces = async () => {
    return fetchWithHandling(`${URL}/races`, target, {
        method: "GET"
    });
}

export const updateRace = async (data) => {
    return fetchWithHandlingNoParse(`${URL}/race`, target, {
        method: "PUT",
        body: JSON.stringify(data)
    });
}

export const deleteRace = async (id) => {
    return fetchWithHandlingNoParse(`${URL}/race/${id}`, target, {
        method: "DELETE"
    });
}


/* Registration Dropdowns - Majors */
export const createMajor = async (data) => {
    return fetchWithHandlingNoParse(`${URL}/major`, target, {
        method: "POST",
        body: JSON.stringify(data)
    });
}

export const getMajors = async () => {
    return fetchWithHandling(`${URL}/majors`, target, {
        method: "GET"
    });
}

export const updateMajor = async (data) => {
    return fetchWithHandlingNoParse(`${URL}/major`, target, {
        method: "PUT",
        body: JSON.stringify(data)
    });
}

export const deleteMajor = async (id) => {
    return fetchWithHandlingNoParse(`${URL}/major/${id}`, target, {
        method: "DELETE"
    });
}



/* Registration Dropdowns - Degree Programs */
export const createDegreeProgram = async (data) => {
    return fetchWithHandlingNoParse(`${URL}/degree`, target, {
        method: "POST",
        body: JSON.stringify(data)
    });
}

export const getDegreePrograms = async () => {
    return fetchWithHandling(`${URL}/degrees`, target, {
        method: "GET"
    });
}

export const updateDegreeProgram = async (data) => {
    return fetchWithHandlingNoParse(`${URL}/degree`, target, {
        method: "PUT",
        body: JSON.stringify(data)
    });
}

export const deleteDegreeProgram = async (id) => {
    return fetchWithHandlingNoParse(`${URL}/degree/${id}`, target, {
        method: "DELETE"
    });
}


/* Registration Dropdowns - Shirt Sizes */
export const createShirtSize = async (data) => {
    return fetchWithHandlingNoParse(`${URL}/shirtSize`, target, {
        method: "POST",
        body: JSON.stringify(data)
    });
}

export const getShirtSizes = async () => {
    return fetchWithHandling(`${URL}/shirtSizes`, target, {
        method: "GET"
    });
}

export const updateShirtSize = async (data) => {
    return fetchWithHandlingNoParse(`${URL}/shirtSize`, target, {
        method: "PUT",
        body: JSON.stringify(data)
    });
}

export const deleteShirtSize = async (id) => {
    return fetchWithHandlingNoParse(`${URL}/shirtSize/${id}`, target, {
        method: "DELETE"
    });
}
